// import { login } from "../config";
import { login } from "../module/payment-panel/shared/service/config";

export default async function postLoginJSON(path, options) {
  const response = await fetch(login + path, options);
  const result = await response.json();

  return result;
}
